import styled, { css } from 'styled-components';
import { FlexBetween } from '../../../../styled/common';
import { Breakpoints } from '../../../../styled/constants';
import { Typography } from '../../../ui/Typography';

export const ResultBlockContainer = styled(FlexBetween)`
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  margin: 0 auto 20px;
  position: relative;
  width: 100%;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    margin-bottom: 30px;
  }
`;

export const TitleContainer = styled(FlexBetween)`
  margin-bottom: 20px;
  width: 100%;
`;

export const ResultBlockTitle = styled(Typography)`
  margin-top: 0;
`;

export const buttonStyles = css`
  > span {
    border: none;
  }
`;

export const ShowAllAdsText = styled(Typography)`
  padding-bottom: 1px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.text.primary};
  transition:
    color 0.3s ease,
    border-color 0.3s ease;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.colors.systemColors.blue};
      border-color: ${({ theme }) => theme.colors.systemColors.blue};
    }
  }
`;
